export default function maskPhoneNumber(phone) {
  if (typeof phone === 'string') {
    return phone.replace(/^(\d{4}).+(\d{2})$/, '+$1*****$2')
  }

  return phone
}
